import React from "react";
import './assets/style.scss';
import 'reactstrap';
import LandingRoutes from "./routers/LandingRoutes";
import HomeRouters from "./routers/HomeRouters";
import Payment from "./pages/PaymentPage/Payment.jsx";
import Themes from './components/Modules/Themes';
import Lesson from './components/lesson-component/Lesson.jsx'
import Tests from './components/Tests/Tests.jsx'
import Table from './components/Table/Table.jsx'
import TestsResult from "./components/Tests/TestsResult";
import Adminpage from "./pages/adminpage/Adminpage";
import Chatsection from "./components/chatsection/Chatsection";
function App() {
  return (
    <div className="App">
   
     <LandingRoutes />
      {/*  <Themes />
      <Lesson />
      <Tests />
      <Table/>  */}
      {/* <TestsResult/> */}
      {/* {/* <Payment/> */}
      <Table/>  
    </div>
  );
}

export default App;
